<template>
  <main class="security-page">
    <AppNavBar :title="t('mine.security')" />

    <section class="security-list">
      <button type="button" class="security-item" @click="router.push('/mine/security/change-password')">
        <div class="security-item__left">
          <app-image src="@/assets/images/settingImage/modify_icon.png" alt="" />
          <span>{{ t('auth.changePassword') }}</span>
        </div>
        <app-image class="security-item__arrow" src="@/assets/images/rightArrow_icon.png" alt="" />
      </button>

      <button type="button" class="security-item" @click="openForgotPassword">
        <div class="security-item__left">
          <app-image src="@/assets/images/settingImage/lock_icon.png" alt="" />
          <span>{{ t('auth.resetPaymentPassword') }}</span>
        </div>
        <app-image class="security-item__arrow" src="@/assets/images/rightArrow_icon.png" alt="" />
      </button>
    </section>
  </main>
</template>

<script setup>
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import AppNavBar from '@/components/AppNavBar.vue';
import { useProfileStore } from '@/stores/profile';

const { t } = useI18n();
const router = useRouter();
const profileStore = useProfileStore();

function openForgotPassword() {
  const email = String(profileStore.currentAccount?.email || '').trim();
  if (!email) {
    showToast(t('auth.bindEmailTip'));
    return;
  }
  router.push('/auth/forgot-pay-password');
}
</script>

<style scoped lang="scss">
.security-page {
  min-height: var(--app-viewport-height);
  background: #fff;
}

.security-list {
  padding: 20px 14px 0;
}

.security-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 34px;
  border: 0;
  background: transparent;
  text-align: left;
}

.security-item__left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.security-item__left .app-image {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.security-item__left span {
  color: #222;
  font-size: 16px;
  line-height: 22px;
}

.security-item__arrow {
  width: 14px;
  height: 14px;
  object-fit: contain;
}
</style>
